// Libs
import { useContext } from "react";

// Utils
import { DomainContext } from "./DomainContext";
import type { DomainType } from "./domains.config";

export function useDomain<K extends keyof DomainType>(key: K): DomainType[K] {
    const domain = useContext(DomainContext)[key];

    return domain;
}
